module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10204.1e6cd360.jpg";